import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  Inject,
  OnInit,
  inject,
  DestroyRef,
  signal,
  ElementRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
  ReactiveFormsModule,
  AbstractControl,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';

import { ErrorStateMatcher } from '@angular/material/core';
import { ParameterService } from '../../../services';
import { ToastAlertService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';

export class parametersErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormGroup | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-parameters-create-modal',
  templateUrl: './parameters-create-modal.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
    MatExpansionModule,
  ],
})
export class ParametersCreateModalComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  public operation: string = '';
  public parametersForm!: FormGroup;
  private paramService = inject(ParameterService);
  private alertService = inject(ToastAlertService);
  private dialogRef = inject(MatDialogRef<ParametersCreateModalComponent>);
  private destroyRef = inject(DestroyRef);
  matcher = new parametersErrorStateMatcher();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private el: ElementRef
  ) {}

  header = signal<string>('Parametro');
  dimension = signal<string>('Valor');
  type = signal<string>('text');
  desciption = signal<string>('');
  maxLength = signal<number>(250);
  maxValue = signal<number | null>(null);
  minValue = signal<number | null>(null);
  readonly panelOpenState = signal(false);
  messageHelpPassword = signal<string>(
    `Hola {{USUARIO}}, tu código de verificación es {{CODIGO}}, recuerda que el token de verificación es válido por {{TIEMPO}} minutos. 
    Te recordamos que tu código de empresa es {{C_EMPRESA}}`
  );

  ngOnInit(): void {
    console.log('data', this.data.action.key);
    if (this.data.action.key === 'Servidor correo') {
      this.parametersForm = this.formBuilder.group({
        id: [this.data.action?.parameterid],
        key: [this.data.action?.key, [Validators.required]],
        senderParameter: ['', [Validators.required, Validators.email]],
        senderPasswordParameter: ['', Validators.required],
        senderHost: ['', Validators.required],
        senderPortParameter: [
          '',
          [
            Validators.required,
            Validators.maxLength(4),
            Validators.minLength(2),
          ],
        ],
      });
      this.chargeEmail();
    } else {
      this.minValue.set(this.data.action?.minValue);
      this.maxValue.set(this.data.action?.maxValue);

      if (this.data.action.key === 'Rango ubicación') {
        this.maxLength.set(50);
      } else if (this.data.action.type === 'number') {
        this.maxLength.set(2);
      }
      if (this.data.action?.parameterid) {
        this.operation = 'Modificar';
        console.log('Dato', this.data.action.type);
        if (this.data.action.type === 'email') {
          this.parametersForm = this.formBuilder.group({
            id: [this.data.action?.parameterid],
            key: [this.data.action?.key, [Validators.required]],
            value: [
              this.data.action?.value,
              [
                Validators.required,
                Validators.maxLength(this.maxLength()),
                Validators.email,
              ],
            ],
            description: [this.data.action?.description, [Validators.required]],
          });
        } else if (typeof this.data.action?.maxValue !== 'number') {
          console.log('Dato 1');
          this.parametersForm = this.formBuilder.group({
            id: [this.data.action?.parameterid],
            key: [this.data.action?.key, [Validators.required]],
            value: [
              this.data.action?.value,
              [Validators.required, Validators.maxLength(this.maxLength())],
            ],
            description: [this.data.action?.description, Validators.required],
          });
        } else {
          console.log('Dato 3');
          this.parametersForm = this.formBuilder.group({
            id: [this.data.action?.parameterid],
            key: [this.data.action?.key, [Validators.required]],
            value: [
              this.data.action?.value,
              [
                Validators.required,
                Validators.maxLength(this.maxLength()),
                this.numberRangeValidator(),
              ],
            ],
            description: [this.data.action?.description, Validators.required],
          });
        }

        this.dimension.set(this.data.action.dimension);
        this.type.set(this.data.action.type);
        this.header.set(this.data.action.key);
        this.desciption.set(this.data.action.description);
      }
    }
  }

  numberRangeValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = parseInt(control.value, 10);
      if (
        isNaN(value) ||
        value < this.minValue()! ||
        value > this.maxValue()!
      ) {
        return {
          numberRangeError: {
            value: control.value,
            minValue: this.minValue(),
            maxValue: this.maxValue(),
          },
        };
      }
      return null;
    };
  }
  async chargeEmail() {
    await this.paramService.getParameterMail().subscribe(resp => {
      this.operation = 'Modificar';
      this.parametersForm = this.formBuilder.group({
        id: [this.data.action?.parameterid],
        key: [this.data.action?.key, [Validators.required]],
        senderParameter: [
          resp.reply.senderParameter,
          [Validators.required, Validators.email],
        ],
        senderPasswordParameter: [
          resp.reply.senderPasswordParameter,
          Validators.required,
        ],
        senderHost: [resp.reply.senderHost, Validators.required],
        senderPortParameter: [
          resp.reply.senderPortParameter,
          [
            Validators.required,
            Validators.maxLength(4),
            Validators.minLength(2),
          ],
        ],
      });

      console.log(this.data.action);
      // se;ales generales
      this.header.set(this.data.action.key);
      this.desciption.set(this.data.action.description);
    });

    if (this.data.action?.parameterid) {
      this.operation = 'Modificar';

      this.dimension.set(this.data.action.dimension);
      this.type.set(this.data.action.type);
      this.header.set(this.data.action.key);
      this.desciption.set(this.data.action.description);
    }
  }
  onKeyDown(event: KeyboardEvent) {
    if (this.type() === 'number') {
      const disallowedKeys = [
        /* Aquí colocas los códigos de las teclas numéricas, por ejemplo: */
        188, 190, 189, 69,
      ];

      if (disallowedKeys.includes(event.keyCode)) {
        event.preventDefault();
      }
    }
  }

  get id_parameters() {
    return this.parametersForm.get('id');
  }
  submit() {
    if (this.parametersForm.valid) {
      if (this.header() === 'Servidor correo') {
        console.log(this.parametersForm.value);
        const body = {
          senderParameter: this.parametersForm.value.senderParameter,
          senderPasswordParameter:
            this.parametersForm.value.senderPasswordParameter,
          senderHost: this.parametersForm.value.senderHost,
          senderPortParameter: this.parametersForm.value.senderPortParameter,
        };
        this.paramService.sendParameterMail(body).subscribe({
          next: (resp: any) => {
            console.log(resp);
            if (resp.code === 10000) {
              this.alertService.sucess('Servidor de Correo modificado.');
              this.dialogRef.close(true);
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
      } else {
        this.updateParameter();
      }
    }
  }

  private updateParameter() {
    console.log(this.data);
    if (this.parametersForm.valid) {
      this.paramService
        .updateParameter(
          this.parametersForm.value,
          Number(this.id_parameters?.value),
          this.data.action.businessId
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            console.log(resp);
            if (resp.code === 10000) {
              this.alertService.sucess('Parámetro modificado');
              this.dialogRef.close(true);
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  clearForm() {
    this.ngOnInit();
  }
}
